/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportControlAiCriteriaMutationVariables = Types.Exact<{
  object: Types.ImportAiCriteriaForControlInput;
}>;

export type ImportControlAiCriteriaMutation = {
  __typename?: 'mutation_root';
  import_ai_criteria_control: string;
};

export const ImportControlAiCriteriaDocument = `
    mutation ImportControlAiCriteria($object: ImportAICriteriaForControlInput!) {
  import_ai_criteria_control(object: $object)
}
    ` as string &
  TypedDocumentNode<ImportControlAiCriteriaMutation, ImportControlAiCriteriaMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportControlAiCriteria: build.mutation<
      ImportControlAiCriteriaMutation,
      ImportControlAiCriteriaMutationVariables
    >({
      query: (variables) => ({ document: ImportControlAiCriteriaDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportControlAiCriteriaMutation } = injectedRtkApi;
